import React from 'react';
import { Locale } from '../../Localization/CustomLocalization.js';

import './css/QuestionCSS.css';
import { CheckBoolean, CheckNumber, CheckObjectNullValue, CheckObjectStringEmpty, CheckStringEmpty, Delay, DelayUntil } from '../../components/GlobalFunctions';      //2023.09.11
import ImageWithRetry from '../../components/ImageWithRetry.js';

export default class Question extends React.Component {

    state = {
        ToggleNext: false,
        ToggleSkip: true,
        Selections: [],
        PictureURL: "",
        imageBlob: null,
        showResultIcon: null,
        toggleShowArticle: false,

        //2021.01.18
        hasHints: false,
        hasInstruction: false,

        //2024.05.23
        submittingAnswer: false,
    }

    componentDidMount = () => {

        const question = this.props.data;
        const Selections = CheckObjectStringEmpty(question, 'Selection').split(';')
            .filter((el) => { return (el.split(':')[1] !== ''); });

        this.setState({
            PictureURL: CheckObjectStringEmpty(question, 'PictureUrl'),
            Selections: Selections,
            toggleShowArticle: Number(this.props.id) + 1 === Number(this.props.qsStart) ? true : false,

            //2021.01.18
            hasHints: CheckObjectNullValue(question, 'Hints') !== null,
            hasInstruction: CheckObjectNullValue(question, 'Instruction') !== null,
        });
    }

    handleClickAnswer = async (event) => {
        if (CheckBoolean(this.props.InActive))
            return null;
        const keyId = Number(event.target.id);
        const selectedAnswer = String(event.target.value);
        const qsAnswer = CheckObjectStringEmpty(this.props.data, 'Answer');
        // const result = qsAnswer === '' ? false : selectedAnswer === qsAnswer;
        const result = qsAnswer === '' ? false : qsAnswer.includes(selectedAnswer);   //2025.11.04 - to support multiple choice.
        this.setState({
            ToggleNext: true,
            toggleShowArticle: false,
            submittingAnswer: true,     //disable buttons.
        });
        const saveDone = await this.props.setAnswer(result, Number(this.props.id), keyId);
        await DelayUntil(() => saveDone === true);
        await Delay(500);
        this.props.CloseAlert();
        this.props.nextQs(Number(this.props.id) + 1, null);
        this.setState({ submittingAnswer: false, });    //reset state.
    }

    convertTagOfColorAndNextline = (_content, extra) => {
        let content = CheckStringEmpty(_content);
        if (content.length > 0) {

            if (content.includes('color')) {
                if (content.includes('green'))
                    content = content.replace(new RegExp('<color=green>', 'g'), '<span style="color:' + String(extra) + 'green;font-weight:bold;">&nbsp;');
                else if (content.includes('blue'))
                    content = content.replace(new RegExp('<color=blue>', 'g'), '<span style="color:blue;font-weight:bold;">&nbsp;');
                else if (content.includes('red'))
                    content = content.replace(new RegExp('<color=red>', 'g'), '<span style="color:red;font-weight:bold;">&nbsp;');

                content = content.replace(new RegExp('</color>', 'g'), '&nbsp;</span>');
            }

            if (content.includes('\n')) {
                content = content.replace(new RegExp('\\n', 'g'), '<br />');
            }

            //added on 2020-11-20
            if (content.includes('\t')) {
                content = String(content).replace(new RegExp('\\t', 'g'), '&#9;');
            }

            //2020.11.24
            if (content.includes('<b>')) {
                content = String(content).replace(new RegExp('<b>', 'g'), '<span style="font-weight:bold;">');
                content = String(content).replace(new RegExp('</b>', 'g'), '</span>');
            }

            //2021.08.25
            if (content.includes('<i>')) {
                content = String(content).replace(new RegExp('<i>', 'g'), '<span style="font-style:italic;">');
                content = String(content).replace(new RegExp('</i>', 'g'), '</span>');
            }

            //2020.11.25
            if (content.includes('<tab/>')) {
                content = String(content).replace(new RegExp('<tab/>', 'g'), '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;');
            }

            //2021.03.25
            if (content.includes('<img>')) {
                content = String(content).replace(new RegExp('<img>', 'g'), '<img src="https://ikeynew.blob.core.windows.net/ikeykidz/JPG/');
                content = String(content).replace(new RegExp('</img>', 'g'), '.jpg" alt="" width="100%">');
            }

            //2021.07.12
            if (content.includes('<jpg>')) {
                content = String(content).replace(new RegExp('<jpg>', 'g'), '<img src="https://ikeynew.blob.core.windows.net/ikeykidz/JPG/');
                content = String(content).replace(new RegExp('</jpg>', 'g'), '.jpg" alt="" width="100%">');
            }
            if (content.includes('<png>')) {
                content = String(content).replace(new RegExp('<png>', 'g'), '<img src="https://ikeynew.blob.core.windows.net/ikeykidz/JPG/');
                content = String(content).replace(new RegExp('</png>', 'g'), '.png" alt="" width="100%">');
            }
        }
        return content;
    }

    getQuestionTitle = (specialMode) => {
        // let title = "<h5><b>" + Locale("question", this.props.UiLocale) + " " + this.props.qsStart + " " + Locale("quiz-qs-comp-to", this.props.UiLocale) + " " + this.props.qsEnd + "</b></h5>";
        let title = "<h5><b>" + Locale("question", this.props.UiLocale) + " " + (Number(this.props.id) + 1) + "</b></h5>";

        //2021.04.02 - disabled by request from May.
        // if (String(specialMode) === 'Comprehension')
        //     title += "<h6>(" + Locale("comprehension", this.props.UiLocale) + ")</h6>";

        // return { __html: title };
        return title;
    }

    getQuestionInnerTitle = () => {
        return "<p>" + Locale("comprehension", this.props.UiLocale) + ' (' + Locale("question", this.props.UiLocale) + this.props.qsStart + Locale("quiz-qs-comp-to", this.props.UiLocale) + this.props.qsEnd + ")</p>";
    }

    getExtraContent = () => {
        return "<p>" + this.convertTagOfColorAndNextline(CheckStringEmpty(this.props.ExtraContent), '') + "</p><br/>";
    }

    getContent = () => {
        return { __html: this.convertTagOfColorAndNextline(CheckStringEmpty(this.props.data.Content), 'light') };
    }

    getPicture = (pictureUrl) => {
        let _pictureUrl = String(pictureUrl);

        if (_pictureUrl.length > 0)
            if (_pictureUrl === 'undefined')
                return '';
            else
                return 'https://ikeynew.blob.core.windows.net/ikeykidz/JPG/' + _pictureUrl + '.jpg';
        else
            return '';

        // // let imageBlob;
        // if (pictureUrl.length > 0)
        //     this.setState({
        //         imageBlob: null,
        //     }, async () => {
        //         await fetch('https://ikeynew.blob.core.windows.net/ikeykidz/JPG/' + pictureUrl + ".jpg")
        //             .then(response => response.blob())
        //             .then(images => {
        //                 // imageBlob = response;
        //                 this.setState({
        //                     imageBlob: URL.createObjectURL(images),
        //                 });
        //                 // alert(response);
        //             })
        //             .catch(error => {
        //                 alert("Unable to load picture.\n\n" + error.code + "\n\n" + error.message);
        //             });
        //     });

        // // return imageBlob;
    }

    getAnswerTextOrPictureComponent = (data) => {
        let answer = String(data).split(':')[1];
        let content = null;
        if (answer !== null && answer !== undefined && answer.includes('_pk_'))
            content = <ImageWithRetry src={this.getPicture(answer)} />;
        else
            content = <div dangerouslySetInnerHTML={{ __html: "<span>" + this.convertTagOfColorAndNextline(answer, '') + "</span>" }} />;
        return content;
    }

    getAnswerTextOrPictureURL = (data) => {
        let answer = String(data).split(':')[1];
        let content = '';
        if (answer !== null && answer !== undefined && answer.includes('_pk_'))
            content = "<img src='" + this.getPicture(answer) + "' alt='' width='80%' />";
        else
            content = "<span>" + this.convertTagOfColorAndNextline(answer, '') + "</span>";
        return content;
    }

    getSelectedAnswerInText = () => {
        let answer = '';
        if (this.state.Selections.length > 0)
            if (CheckStringEmpty(this.props.ASelectId) !== '-1' || CheckNumber(this.props.ASelectId) >= 0)
                answer = String(this.state.Selections[Number(this.props.ASelectId)]).split(':')[0];
        return answer;
    }

    //2021.01.18
    getHints = () => {
        return '<p> Hints: ' + this.convertTagOfColorAndNextline(CheckStringEmpty(this.props.data.Hints), 'light') + '</p>';
    }

    //2021.01.18
    getInstruction = () => {
        return '<p>' + this.convertTagOfColorAndNextline(CheckStringEmpty(this.props.data.Instruction), 'light') + '</p>';
    }

    render = () => {
        return (
            <>
                <div className="row" style={{ paddingBottom: 5, }}>
                    <div className="col col-sm-5">
                        <div dangerouslySetInnerHTML={{ __html: this.getQuestionTitle(this.props.SpecialMode) }} />
                    </div>
                    <div className="col col-sm-7 text-right">
                        {
                            CheckBoolean(this.props.InActive) && CheckStringEmpty(this.props.ASelectId, '-1') === "-1" ?
                                <>
                                    <span>{Locale("quiz-times-up", this.props.UiLocale)}</span>&nbsp;
                                    <i className="fa fa-remove" style={{ fontSize: "24px", color: "red" }}></i>
                                </>
                                :
                                CheckBoolean(this.props.ShowResultIcon) ?
                                    // String(this.props.data.Answer) === this.getSelectedAnswerInText() ?
                                    //2025.11.04 - to support multiple choice.
                                    CheckObjectStringEmpty(this.props.data, 'Answer').includes(this.getSelectedAnswerInText()) ?
                                        <i className="fa fa-check" style={{ fontSize: "24px", color: "green" }}></i>
                                        :
                                        <i className="fa fa-remove" style={{ fontSize: "24px", color: "red" }}></i>
                                    : null
                        }
                    </div>
                </div>
                <div className="questionsBox">
                    {
                        CheckStringEmpty(this.props.SpecialMode) === 'Comprehension' ?
                            <>
                                <div className="row">
                                    <div className="col col-sm-12">
                                        <div dangerouslySetInnerHTML={{ __html: this.getQuestionInnerTitle() }} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col col-sm-12">
                                        <button
                                            className="btn btn-primary btn-block" id="showArticle"
                                            onClick={() => {
                                                this.setState({ toggleShowArticle: !this.state.toggleShowArticle });
                                            }}
                                        >{this.state.toggleShowArticle ? Locale("hide-article", this.props.UiLocale) : Locale("show-article", this.props.UiLocale)}</button>
                                        <span>&nbsp;</span>
                                    </div>
                                </div>
                                {
                                    this.state.toggleShowArticle ?
                                        <div className="row">
                                            <div className="col col-sm-12">
                                                <div dangerouslySetInnerHTML={{ __html: this.getExtraContent() }} />
                                            </div>
                                        </div>
                                        : null
                                }
                            </>
                            : null
                    }
                    <div className="questions">
                        {
                            //2021.01.18
                            this.state.hasInstruction ? <div dangerouslySetInnerHTML={{ __html: this.getInstruction() }} /> : null
                        }
                        <div dangerouslySetInnerHTML={this.getContent()} />
                        {
                            //2021.01.18
                            this.state.hasHints ? <div dangerouslySetInnerHTML={{ __html: this.getHints() }} /> : null
                        }
                    </div>
                    {
                        this.state.PictureURL.length > 0 ?
                            <div className="questionPicture">
                                {/* <img src={this.getPicture(this.state.PictureURL)} alt={''} width={'100%'} /> */}
                                <ImageWithRetry src={this.getPicture(this.state.PictureURL)} />
                            </div>
                            : null
                    }
                    <ul
                        className={CheckBoolean(this.props.InActive) || this.state.submittingAnswer ? "answerList-inactive" : "answerList"}
                        style={{
                            border: '1px solid lightgray',
                            borderRadius: 5,
                            padding: '6px 7px 5px 48px',
                        }}
                    >
                        {
                            this.state.Selections.map((data, key) => {
                                if (String(data).length > 0) {
                                    const checked = key === Number(this.props.ASelectId);
                                    return (
                                        <li key={'A_' + key}>
                                            <label style={checked ? { backgroundColor: 'beige' } : {}}>
                                                <div className="row">
                                                    <div className="col-1 ans-col-1">
                                                        <input
                                                            type="radio"
                                                            className="radio"
                                                            name={"Q" + this.props.id + "_ag"}
                                                            value={String(data).split(":")[0]}
                                                            // id={"Q" + this.props.id + "_" + key}
                                                            id={key}
                                                            onClick={this.handleClickAnswer}
                                                            checked={checked}
                                                            disabled={CheckBoolean(this.props.InActive) || this.state.submittingAnswer}
                                                            readOnly={true}
                                                        />
                                                    </div>
                                                    <div className="col-1 textBold ans-col-2-cols">{String(data).split(":")[0]}</div>
                                                    <div className={(window.innerWidth < 576 ? "col-7" : "col-9") + " ans-col-2-cols"}>
                                                        {/* <div dangerouslySetInnerHTML={{ __html: this.getAnswerTextOrPictureURL(data) }} /> */}
                                                        {this.getAnswerTextOrPictureComponent(data)}
                                                    </div>
                                                    <div className="col-1 ans-col-2-cols">
                                                        {
                                                            //show the correct answer if answered wrong.
                                                            // this.props.ShowResultIcon && String(data).split(':')[0] === String(this.props.data.Answer) ?
                                                            //2025.11.04 - to support multiple choice.
                                                            CheckBoolean(this.props.ShowResultIcon) && CheckObjectStringEmpty(this.props.data, 'Answer').includes(String(data).split(':')[0]) ?
                                                                <i className="fa fa-star" style={{ fontSize: "20px", color: "blue" }}></i>
                                                                :
                                                                <span>&nbsp;</span>
                                                        }
                                                    </div>
                                                </div>
                                            </label>
                                        </li>
                                    );
                                }
                                return null;
                            })
                        }
                    </ul>

                    <div className="questionsRow">
                        <div className="row">
                            <div className="col col-sm-3">
                                <button
                                    className="btn btn-secondary btn-block" id="skipquestions"
                                    onClick={() => {
                                        this.setState({
                                            toggleShowArticle: false
                                        }, () => {
                                            this.props.nextQs(Number(this.props.id) + 1, null);
                                        });
                                    }}
                                    hidden={Number(this.props.total) > Number(this.props.id) + 1 ? !this.state.ToggleSkip : true}
                                    style={{ fontSize: window.innerWidth < 576 ? 14 : 16, }}
                                >{Locale("next", this.props.UiLocale)}</button>
                            </div>
                            <div className="col col-sm-6 text-center" style={{ padding: 0, fontSize: window.innerWidth < 576 ? 14 : 16, }}>
                                <span>{Number(this.props.id) + 1} / {this.props.total}</span>
                            </div>
                            <div className="col col-sm-3">
                                <a href="#quiz-pos-q-result" hidden={!this.props.ShowResultBtn}>
                                    <button
                                        className="btn btn-primary btn-block"
                                        style={{ fontSize: window.innerWidth < 576 ? 14 : 16, }}
                                    >{Locale("goto-result", this.props.UiLocale)}</button>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}